export const ALLROOMS = [
    {
        id: 0,
        name: "Social Studies",
        rooms: [
            {
                id: 0,
                desc: "Renaissance",
                src: "http://charlessuits.org/sites/MrSuits.net/renais"
            },
            {
                id: 1,
                desc: "Explorers",
                src: "http://charlessuits.org/sites/MrSuits.net/explorer"
            },
            {
                id: 2,
                desc: "Ancient Civilizations",
                src: "http://charlessuits.org/sites/MrSuits.net/ancient"
            },
            {
                id: 3,
                desc: "The Middle Ages",
                src: "http://charlessuits.org/sites/MrSuits.net/MiddleAges"
            },
            {
                id: 4,
                desc: "100 Famous People",
                src: "http://charlessuits.org/sites/MrSuits.net/famous"
            },
            {
                id: 5,
                desc: "Social Studies",
                src: "http://charlessuits.org/sites/MrSuits.net/social"
            }

        ]
       
    },
    {
        id: 1,
        name: "Science",
        rooms: [
            {
                id: 0,
                desc: "Snakes and Stuff",
                src: "http://charlessuits.org/sites/MrSuits.net/bioroom"
            },
            {
                id: 1,
                desc: "Science",
                src: "http://charlessuits.org/sites/MrSuits.net/science"
            },
            {
                id: 2,
                desc: "Math",
                src: "http://charlessuits.org/sites/MrSuits.net/math"
            }
        ]
    },
    {
        id: 2,
        name: "Teachers",
        rooms: [
            {
                id: 0,
                desc: "21st Century Teaching",
                src: "http://charlessuits.org/sites/MrSuits.net/21st"
            },
            {
                id: 1,
                desc: "Creativity Resources",
                src: "http://charlessuits.org/sites/MrSuits.net/Creativity"
            },
            {
                id: 2,
                desc: "Fairy Tales",
                src: "http://charlessuits.org/sites/MrSuits.net/Fairy"
            },
            {
                id: 3,
                desc: "Reading",
                src: "http://charlessuits.org/sites/MrSuits.net/reading"
            },
            {
                id: 4,
                desc: "Writing",
                src: "http://charlessuits.org/sites/MrSuits.net/writing"
            },
            {
                id: 5,
                desc: "Music",
                src: "http://charlessuits.org/sites/MrSuits.net/music"
            },
            {
                id: 6,
                desc: "Pre-Renaissance Spain",
                src: "http://charlessuits.org/sites/MrSuits.net/spanish"
            },
            {
                id: 7,
                desc: "Help Students with College",
                src: "http://charlessuits.org/sites/MrSuits.net/college"
            }
        ]
    },
    {
        id: 4,
        name: "Fun  Learning",
        rooms: [
            {
                id: 0,
                desc: "The World of Wonder",
                src: "http://charlessuits.org/sites/MrSuits.net/wonder"
            },
            {
                id: 1,
                desc: "Research for Elementary",
                src: "http://charlessuits.org/sites/MrSuits.net/research"
            },
            {
                id: 2,
                desc: "Research for Higher School",
                src: "http://charlessuits.org/sites/MrSuits.net/Symbaloo/index.html"
            },
            {
                id: 3,
                desc: "Reading",
                src: "http://charlessuits.org/sites/MrSuits.net/reading"
            },
            {
                id: 4,
                desc: "Writing",
                src: "http://charlessuits.org/sites/MrSuits.net/writing"
            },
            {
                id: 5,
                desc: "Music",
                src: "http://charlessuits.org/sites/MrSuits.net/music"
            },
            {
                id: 6,
                desc: "Pre-Renaissance Spain",
                src: "http://charlessuits.org/sites/MrSuits.net/spanish"
            },
            {
                id: 7,
                desc: "Help Students with College",
                src: "http://charlessuits.org/sites/MrSuits.net/college"
            }
        ]
    }
    
];
export const ALLDIS = [
    {
        id: 0,
        desc: "AERO",
        src: "http://charlessuits.org/sites/MrSuits.net/charlessuits/img/disAERO.png"
    },
    {
        id: 1,
        desc: "Application",
        src: "http://charlessuits.org/sites/MrSuits.net/charlessuits/img/disAppl.png"
    },
    {
        id: 2,
        desc: "International",
        src: "http://charlessuits.org/sites/MrSuits.net/charlessuits/img/disIntr.png"
    },
    {
        id: 3,
        desc: "Schedule",
        src: "http://charlessuits.org/sites/MrSuits.net/charlessuits/img/disSced.png"
    },
    {
        id: 4,
        desc: "DIS",
        src: "http://charlessuits.org/sites/MrSuits.net/charlessuits/img/disDIS.png"
    },
    {
        id: 5,
        desc: "Inquiry",
        src: "http://charlessuits.org/sites/MrSuits.net/charlessuits/img/inquiry.png"
    },
    {
        id: 6,
        desc: "Maker",
        src: "http://charlessuits.org/sites/MrSuits.net/charlessuits/img/maker.png"
    },
    {
        id: 7,
        desc: "PYP",
        src: "http://charlessuits.org/sites/MrSuits.net/charlessuits/img/disPYP.png"
    },
    {
        id: 8,
        desc: "Staff",
        src: "http://charlessuits.org/sites/MrSuits.net/charlessuits/img/disStaff.png"
    },
    {
        id: 9,
        desc: "Mission 1",
        src: "http://charlessuits.org/sites/MrSuits.net/charlessuits/img/disMission1.png"
    },
    {
        id: 10,
        desc: "Mission 2",
        src: "http://charlessuits.org/sites/MrSuits.net/charlessuits/img/disMission2.png"
    }
    
];
